import parse from 'html-react-parser';

import SimpleButton from './SimpleButton';

export default function TwoColumnImage({ blockInfo }) {
    return (
        <div className="overflow-hidden" style={{ backgroundColor: blockInfo.backgroundColor }}>
            <div className="relative mx-auto max-w-7xl py-8 px-6 lg:px-8">
                <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
                    <div className={`relative lg:row-start-1 ${blockInfo?.imageColumnPosition === 'left' ? 'lg:col-start-1' : 'lg:col-start-2'}`}>
                        <div className="relative mx-auto max-w-prose text-base lg:max-w-none">
                            <img
                                className="rounded-lg object-contain w-full"
                                src={blockInfo?.image?.url}
                                alt=""
                                loading='lazy'
                            />
                        </div>
                    </div>
                    <div className="mt-8 lg:mt-0 ">
                        <div className='mx-auto max-w-prose' style={{ color: blockInfo?.textColor }}>
                            {parse(blockInfo?.columnText ?? '')}
                        </div>
                        {blockInfo.button !== null && <div className='mt-3 '>
                            <SimpleButton blockInfo={blockInfo.button} />
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}
